var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3044 27.7101C11.3428 16.4019 20.541 7.2659 31.8493 7.3042C43.1575 7.34274 52.2935 16.541 52.2552 27.8492V28.0811C52.1159 35.4319 48.0116 42.2261 42.9797 47.5362C40.102 50.5245 36.8884 53.1701 33.4029 55.4203C32.4709 56.2264 31.0885 56.2264 30.1565 55.4203C24.9605 52.0382 20.4002 47.7683 16.6841 42.8058C13.372 38.4783 11.4915 33.2259 11.3044 27.7797V27.7101Z",
    fill: "#FFD058",
    stroke: "black",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7797 34.6666C35.404 34.6666 38.342 31.7286 38.342 28.1043C38.342 24.48 35.404 21.542 31.7797 21.542C28.1555 21.542 25.2174 24.48 25.2174 28.1043C25.2174 31.7286 28.1555 34.6666 31.7797 34.6666Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationMarker);
export default __webpack_public_path__ + "static/media/ic_location-marker.c4d75284bb6b409791a89bd50e960221.svg";
export { ForwardRef as ReactComponent };